import script from "./DepositConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./DepositConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./DepositConfirmation.vue?vue&type=style&index=0&id=11cbe42e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11cbe42e"]])

export default __exports__